export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/librarySvg.acfdb0ec.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};